export default __webpack_public_path__ + "static/light-mode-cat-88f04043eac8d157b5f6d7b8fce3edad08ed450197e8fcd70030dc9d46fc412c.png";